import { render, staticRenderFns } from "./rewardHistory.vue?vue&type=template&id=4701ca12&scoped=true"
import script from "./rewardHistory.vue?vue&type=script&lang=js"
export * from "./rewardHistory.vue?vue&type=script&lang=js"
import style0 from "./rewardHistory.vue?vue&type=style&index=0&id=4701ca12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701ca12",
  null
  
)

export default component.exports